import React from 'react';
import { FAQItem } from './types';

export const EU_FAQS: FAQItem[] = [
  {
    id: 'phone-carrier-requirement',
    titleKey: 'do_i_need_a_specific_phone_carrier_to_use_fi',
    answerKey:
      'fi_works_with_any_smartphone_regardless_of_your_phone_carrier_the_fi_collar_has_its_own_built_in_sim_and_connects_to_mobile_networks_independently_just_download_the_fi_app_to_start_tracking',
  },
  {
    id: 'stolen-dog-recovery',
    titleKey: 'how_does_fi_help_if_my_dog_is_stolen',
    answerKey:
      'fi_has_helped_many_owners_recover_stolen_dogs_using_real_time_gps_tracking_and_instant_alerts_the_moment_a_fi_dog_leaves_a_safe_zone_the_collar_is_discreet_secure_and_cant_be_removed_without_you_knowing',
  },
  {
    id: 'why-membership-eu',
    titleKey: 'why_is_fi_a_membership',
    answerContent: (t) => (
      <>
        {t(
          'the_fi_membership_provides_a_lower_cost_way_for_customers_to_try_the_most_advanced_technology_for_their_dogs_without_a_high_upfront_cost_fi_also_believes_in_continuing_to_deliver_new_features_analytics_and_benefits_and_a_membership_model_allows_us_to_continue_investing_in_the_best_possible_customer_experience',
        )}
        <br />
        <br />
        {t(
          'your_membership_includes_unlimited_cellular_service_and_gps_access_as_well_as_a_family_plan_so_you_can_share_your_account_with_everyone_who_cares_for_your_dog',
        )}
      </>
    ),
  },
  {
    id: 'multi-dog-discounts',
    titleKey: 'do_you_offer_discounts_for_multiple_dogs',
    answerKey:
      'we_offer_multi_collar_bundles_at_a_reduced_rate_each_dog_needs_their_own_collar_and_membership_but_when_you_add_multiple_collars_to_your_order_bundle_pricing_is_applied_contact_us_if_you_have_3_plus_dogs_for_custom_pricing_options',
  },
  {
    id: 'existing-member-device',
    titleKey: 'can_i_get_a_new_device_if_im_already_a_fi_member',
    answerKey: 'can_i_get_a_new_device_if_im_already_a_fi_member_answer',
  },
  {
    id: 'new-hardware',
    titleKey: 'what_happens_when_a_new_generation_of_hardware_is_released',
    answerKey:
      'when_you_have_an_active_fi_membership_you_dont_have_to_worry_about_having_outdated_hardware_you_are_eligible_to_upgrade_to_the_latest_hardware_at_a_discounted_price',
  },
  {
    id: 'data-protection-gdpr',
    titleKey: 'how_is_my_data_protected',
    answerKey:
      'fi_takes_data_privacy_seriously_we_comply_with_gdpr_and_uk_data_protection_regulations_and_we_encrypt_and_securely_store_your_dogs_location_and_health_data_you_can_request_data_deletion_at_any_time_through_the_app_settings',
  },
];
